'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidVolumeUp = function IoAndroidVolumeUp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5 15h6.6l8.4-8.7v27.5l-8.4-8.8h-6.6v-10z m22.5 5c0 3-1.6 5.7-4.1 6.9v-13.9c2.5 1.3 4.1 4 4.1 7z m-4.1-15c6.6 1.6 11.6 7.7 11.6 15s-5 13.4-11.6 15v-3.5c4.8-1.5 8.2-6.1 8.2-11.5s-3.4-10-8.2-11.5v-3.5z' })
        )
    );
};

exports.default = IoAndroidVolumeUp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-volume-up.js
// module id = 1924
// module chunks = 0